import { Component } from '@opten/compiler/metadata/component';
import { FormTemplatesComponent } from './form-templates';

@Component({ className: 'js-form-select-updater' })
export class FormSelectUpdateComponent {
	private items: HTMLInputElement[];
	private targets: HTMLSelectElement[];

	constructor(private element: HTMLElement) {
		this.items = Array.from(
			this.element.querySelectorAll('.js-form-select-updater-item')
		) as HTMLInputElement[];
		this.targets = Array.from(
			document.querySelectorAll('.js-form-select-updater-target')
		) as HTMLSelectElement[];

		if (
			this.items &&
			this.items.length > 0 &&
			this.targets &&
			this.targets.length > 0
		) {
			this.items.forEach((item) => {
				this.setupItem(item);
			});
		}

		FormTemplatesComponent.onFieldAdded.subscribe((field) => {
			this.update(field);
		});
		FormTemplatesComponent.onFieldRemoved.subscribe((field) => {
			this.updateRemoving(field);
		});
	}

	private setupItem(item: HTMLInputElement) {
		item.setAttribute('data-old-val', item.value);
		item.addEventListener('change', (e) => {
			this.updateTargets(item.getAttribute('data-old-val'), item.value);
			item.setAttribute('data-old-val', item.value);
		});
	}

	private updateTargets(oldValue: string, newValue: string) {
		this.targets.forEach((target) => {
			let item = Array.from(target.options).find(o => o.value == oldValue);
			if (!oldValue && !newValue) {
				if (item) {
					item.remove();
				}
				return;
			}
			if (!newValue && item) {
				item.remove();
				return;
			}
			if (!item) {
				item = document.createElement('option');
				target.add(item, null);
			}
			item.text = newValue;
			item.value = newValue;
		});
	}

	private createTargets(targets: HTMLSelectElement[]) {
		targets.forEach((target) => {
			while (target.options.length > 0) {
				target.remove(target.options.length - 1);
			}
			for (let i = 0; i < this.items.length; i++) {
				var opt = document.createElement('option');
				opt.text = this.items[i].value;
				opt.value = this.items[i].value;
				opt.selected = i == 0;
				target.add(opt, null);
			}
		});
	}

	private update(field: HTMLElement) {
		const item = field.querySelector(
			'.js-form-select-updater-item'
		) as HTMLInputElement;
		if (item) {
			this.items.push(item);
			this.setupItem(item);
		}

		const targets = Array.from(
			field.querySelectorAll('.js-form-select-updater-target')
		) as HTMLSelectElement[];
		if (targets && targets.length > 0) {
			this.targets = this.targets.concat(targets);
			this.createTargets(targets);
		}
	}

	private updateRemoving(field: HTMLElement) {
		const item = field.querySelector(
			'.js-form-select-updater-item'
		) as HTMLInputElement;
		if (item) {
			this.items.splice(this.items.indexOf(item), 1);
			this.updateTargets(item.value, undefined);
		}
	}
}
